import { Grid } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../../../../store'
import { MatchedPFActions } from '../../../../../../store/matchedPF'
import { MatchedPFsActions, MatchedPFsSelectors } from '../../../../../../store/matchedPFs'
import { PFCard } from './PFCard'
import { PFSlideOut } from './PFSlideOut'

export const PrivateFoundations: FC = () => {
  const dispatch = useDispatch<AppDispatch>()

  const [showPFDetail, setShowPFDetail] = useState(false)

  const pfs = useSelector(MatchedPFsSelectors.makeMatchedPFs)

  useEffect(() => {
    const options = {
      params: {
        $limit: 4,
      },
    }
    dispatch(MatchedPFsActions.fetchCurrentUserMatchedPFsAsync({ options }))
  }, [dispatch])

  const handlePFSlideOut = (technologyId: string, refId: string) => {
    dispatch(
      MatchedPFActions.fetchMatchedPFAsync({
        technologyId,
        refId,
        options: { params: { $includes: 'privateFoundation' } },
      }),
    )
    setShowPFDetail(true)
  }

  return (
    <Grid my={2} container spacing={2}>
      <PFSlideOut open={showPFDetail} setOpen={setShowPFDetail} />

      {pfs &&
        pfs.map((pf) => {
          return (
            <PFCard
              key={pf._id}
              refId={pf.einNumber}
              technologyId={pf.technologyId}
              amount={pf.formattedCharityAmount}
              technologyTitle={pf.technologyTitle}
              organizationName={pf.organizationName}
              handlePFSlideOut={handlePFSlideOut}
            />
          )
        })}
    </Grid>
  )
}
